<template>
  <div class="mt-10 flex w-full items-center justify-between gap-10">
    <IAIScrollableContainer>
      <div class="flex flex-row">
        <IAIButton
          class="mr-2 h-10 flex-shrink-0"
          :label="$t('pages.profile-shop.filters.button')"
          :icon-src="Icons.Filter.src"
          icon-side="end"
          variant="outline"
          size="small"
          @click="$emit('openFilterPanel')"
        />

        <QuickFilters
          v-show="mobile_or_desktop === 'desktop'"
          class="min-w-0 flex-1"
          :filters="quickFilters"
          @toggleFilter="(filter) => toggleFilter(filter.group, filter.key, ToggleFilterSource.QuickFilter)"
        />
      </div>
    </IAIScrollableContainer>

    <SortSelect />
  </div>
</template>

<script lang="ts" setup>
import QuickFilters from "@/features/profile-shop/components/filters/toolbar/QuickFilters.vue";
import SortSelect from "@/features/profile-shop/components/filters/toolbar/SortSelect.vue";
import { IAIButton, Icons, IAIScrollableContainer } from "@/core-ui-vue";
import { universalStorage } from "@/utils/universal-storage";
import { useProfileShopFilters, ToggleFilterSource } from "@/features/profile-shop/composables/useProfileShopFilters";

const emit = defineEmits<{
  (e: "openFilterPanel"): void;
}>();

const profileShopFilters = useProfileShopFilters();

const { toggleFilter, quickFilters } = profileShopFilters;

const mobile_or_desktop = universalStorage.get("mobile_or_desktop");
</script>
